import './App.css';
import { Routes, Route } from 'react-router-dom';
import Entry from './components/Entry.jsx';
import Login from './components/Login.jsx';
import Register from './components/Register.jsx';
import CreatePlot from './components/CreatePlot.jsx';
import HowItWorks from './components/HowItWorks.jsx';
import HelpCenter from './components/HelpCenter.jsx';
import Search from './components/Search.jsx';
import SingleCategory from './components/SingleCategory.jsx';
import EventDetails from './components/EventDetails.jsx';
import Events from './components/Events.jsx';
import PassedEvents from './components/PassedEvents.jsx';
import Notifications from './components/Notifications.jsx';
import TestNotifications from './components/TestNotifications.jsx';
import ForgotPassword from './components/ForgotPassword.jsx';
import 'animate.css';
import TicketPurchase from './components/TicketPurchase.jsx';
import GeneratedTickets from './components/GeneratedTickets.jsx';
import { useLoadingContext } from './components/LoadingContext.jsx';
import Loader from './components/Loader.jsx';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import HelpCenterInfo from './components/HelpCenterInfo.jsx';
import HowItWorksDetails from './components/HowItWorksDetails.jsx';
import PasswordResetForm from './components/PasswordResetForm.jsx';
import MyEvents from './components/MyEvents.jsx';
import UserProfile from './components/UserProfile.jsx';
import RevenueDashboard from './components/RevenueDashboard.jsx';
import RouteLogger from './components/RouterLogger.jsx';
import UrlProvider from './components/RouterLogger.jsx';
import MyPaymentRequests from './components/MyPaymentRequests.jsx';
import Admin from './components/Admin.jsx';
import ScrollToTop from './components/ScrollToTop.jsx';
import Activation from './components/Activation.jsx';
import NotFoundPage from './components/NotFoundPage.jsx';
import Faq from './components/Faq.jsx';
import EventCategories from './components/EventCategories.jsx';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import AboutUs from './components/AboutUs.jsx';
import ContactUs from './components/ContactUs.jsx';
import Privacy from './components/Privacy.jsx';
import Terms from './components/Terms.jsx';


function App() {
  const { loading } = useLoadingContext()
  return (
    <UrlProvider>
      <div className="App">
        <ScrollToTop />
        <RouteLogger />
        <ToastContainer />
        {loading && <Loader />}
        <Routes>
          <Route path='/' element={<Entry />} />
          <Route path='/login' element={<Login />} />
          <Route path='/accounts/activation/:uid/:token' element={<Activation />} />
          <Route path='/forgot-password' element={<ForgotPassword />} />
          <Route path="/reset-password/:slug/:token/" element={<PasswordResetForm />} />
          <Route path='/accounts/profile' element={<UserProfile />} />
          <Route path='/register' element={<Register />} />
          <Route path='/create-plot' element={<CreatePlot />} />
          <Route path='/frequently-asked-questions' element={<Faq />} />
          <Route path='/faq' element={<Faq />} />
          <Route path='/how-it-works' element={<HowItWorks />} />
          <Route path='/how-it-works/:name' element={<HowItWorksDetails />} />
          <Route path='/help-center' element={<HelpCenter />} />
          <Route path='/help-center/:name' element={<HelpCenterInfo />} />
          <Route path='/search' element={<Search />} />
          <Route path='/categories' element={<EventCategories />} />
          <Route path='/categories/:name' element={<SingleCategory />} />
          <Route path='/events' element={<Events />} />
          <Route path='/passed-events' element={<PassedEvents />} />
          <Route path='/notifications' element={<Notifications />} />
          <Route path='/test-notifications' element={<TestNotifications />} />
          <Route path='/events/:name' element={<EventDetails />} />
          <Route path='/ticket-purchase' element={<TicketPurchase />} />
          <Route path='/generated-tickets' element={<GeneratedTickets />} />
          <Route path='/about' element={<AboutUs />} />
          <Route path='/contact' element={<ContactUs />} />
          <Route path='/privacy' element={<Privacy />} />
          <Route path='/terms' element={<Terms />} />
          <Route element={<ProtectedRoute />}>
            <Route path='/my-events' element={<MyEvents />} />
            <Route path='/my-revenue' element={<RevenueDashboard />} />
            <Route path='/my-payment-requests' element={<MyPaymentRequests />} />
            <Route path='/admin' element={<Admin />} />
            <Route path='/settings' element={<UserProfile />} />
          </Route>
          <Route path="*" element={< NotFoundPage />} />
        </Routes>
      </div>
    </UrlProvider>
  );
}

export default App;
